import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Problem } from "@/components/sections/Problem";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { Features } from "@/components/sections/Features";
import { ProductShowcase } from "@/components/sections/ProductShowcase";
import { Industries } from "@/components/sections/Industries";
import { WhyAnchor } from "@/components/sections/WhyAnchor";
import { Faq } from "@/components/sections/Faq";
import { DemoForm } from "@/components/sections/DemoForm";
import { FinalCta } from "@/components/sections/FinalCta";
import { Footer } from "@/components/sections/Footer";
import PublicDemo from "@/pages/PublicDemo";
import AdminDemos from "@/pages/AdminDemos";
import NotFound from "@/pages/NotFound";

const Landing = () => (
  <div className="App bg-background">
    <Navbar />
    <main>
      <Hero />
      <Problem />
      <HowItWorks />
      <Features />
      <ProductShowcase />
      <Industries />
      <WhyAnchor />
      <Faq />
      <DemoForm />
      <FinalCta />
    </main>
    <Footer />
    <Toaster position="top-center" richColors />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/demo/:slug" element={<PublicDemo />} />
        <Route path="/admin/demos" element={<AdminDemos />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
